import JSZip from 'jszip';
import shp from 'shpjs';
import shpwrite from '@mapbox/shp-write';

export const nomeBase = nome => nome
    .replace(/\.(zip|shp|xlsx|xls|csv|kml|kmz)$/i, '')
    .replace(/[_\-\s]*(zones?|zonas?|points?|pontos?)$/i, '')
    .trim();

export const nomeSeguro = nome => (nome || 'arquivo')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9_-]+/g, '_')
    .replace(/^_+|_+$/g, '') || 'arquivo';

export const baixarBlob = (blob, nome) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = nome;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 1500);
};

export const lerShapeZip = async arquivo => {
    const resultado = await shp(await arquivo.arrayBuffer());
    const colecoes = Array.isArray(resultado) ? resultado : [resultado];
    const features = colecoes.reduce(
        (todos, item) => todos.concat(item.features || []),
        []
    );
    if (!features.length) {
        throw new Error(`${arquivo.name}: nenhum elemento geográfico encontrado.`);
    }
    return { type: 'FeatureCollection', features };
};

export const identificar = propriedades => {
    const chaves = Object.keys(propriedades || {});
    const chave = chaves.find(item => [
        'id', 'nome', 'descricao', 'descrição', 'zona'
    ].includes(item.toLowerCase())) || chaves[0];
    return chave ? String(propriedades[chave] || '').trim() : '';
};

export const shapeZip = async (colecao, pasta, nome) => {
    const resultado = shpwrite.zip(colecao, {
        folder: pasta,
        outputType: 'arraybuffer',
        compression: 'DEFLATE',
        types: {
            point: nome,
            polygon: nome,
            multipolygon: nome
        }
    });
    return resultado instanceof ArrayBuffer
        ? resultado
        : await resultado;
};

export const pacoteZip = async (arquivos, nome) => {
    const zip = new JSZip();
    arquivos.forEach(item => zip.file(item.nome, item.conteudo));
    const blob = await zip.generateAsync({
        type: 'blob',
        compression: 'DEFLATE'
    });
    baixarBlob(blob, nome);
};

export const kml = colecao => {
    const geometrias = colecao.features.map((feature, indice) => {
        const geometria = feature.geometry || {};
        const poligonos = geometria.type === 'Polygon'
            ? [geometria.coordinates]
            : geometria.type === 'MultiPolygon'
                ? geometria.coordinates : [];
        const conteudo = poligonos.map(poligono => {
            const anel = poligono[0] || [];
            return `<Polygon><outerBoundaryIs><LinearRing><coordinates>${anel
                .map(ponto => `${ponto[0]},${ponto[1]},0`).join(' ')
            }</coordinates></LinearRing></outerBoundaryIs></Polygon>`;
        }).join('');
        return `<Placemark><name>${identificar(feature.properties) ||
            `Área ${indice + 1}`}</name><MultiGeometry>${conteudo
        }</MultiGeometry></Placemark>`;
    }).join('');
    return `<?xml version="1.0" encoding="UTF-8"?><kml xmlns="http://www.opengis.net/kml/2.2"><Document>${geometrias}</Document></kml>`;
};
